import { useAuth } from '@/services/auth/use-auth'

import { SheetMenu } from './sheet-menu'
import { UserNav } from './user-nav'

interface NavbarProps {
  title?: string
}

export function Navbar({ title }: NavbarProps) {
  const user = useAuth((s) => s.user)
  return (
    <header className="sticky top-0 z-10 w-full border-b bg-background backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="mx-4 flex h-14 items-center sm:mx-8">
        <div className="flex items-center space-x-4 lg:space-x-0">
          <SheetMenu />
          {title && <h1 className="font-bold">{title}</h1>}
        </div>
        {user?.id && (
          <div className="flex flex-1 items-center justify-end">
            <UserNav user={user} />
          </div>
        )}
      </div>
    </header>
  )
}
